import React from "react";
import jsPDF from "jspdf";
import stylez from "../Customer.module.css";

function PrintPDF({ data, customerData }) {
  console.log(data);
  const selectedData = customerData.filter((customer) =>
    data.includes(customer._id)
  );
  const createPdf = () => {
    const doc = new jsPDF();
    let rows = [];
    const date = new Date();

    // Iterate through the data and add it to the rows array
    doc.text("CustomersList", "10", "10");
    doc.text(`Date-${date.toLocaleDateString("en-GB")}`, "150", "10");

    selectedData.forEach((customer) => {
      rows.push([
        customer.businessName,
        customer.abn,
        customer.pic,
        customer.customer_type,
        customer.address,
        customer.email,
        customer.phone,
      ]);
    });

    // Add the table to the PDF
    doc.autoTable({
      head: [
        ["Name", "Abn", "PIC", "Customer Type", "Address", "Email", "Phone"],
      ],
      body: rows,
      headStyles: { fillColor: [0, 0, 0] },
      styles: {
        cellPadding: 5,
        fontSize: 9,
        fontStyle: "bold",
      },
    });
    // Save the PDF
    doc.save("CustomerData.pdf");
  };

  return (
    <div>
      <button
        className={stylez.printBtn}
        onClick={() => {
          createPdf();
        }}
      >
        Download Selected Pdf's
      </button>
    </div>
  );
}

export default PrintPDF;
